import React from 'react';
import PropTypes from 'prop-types';

import { profilePictureStyle } from './styles';

export const ProfilePicture = ({ image, size, sizesAt }) => {
	return (
		<div className={profilePictureStyle(size, sizesAt)} data-component="ProfilePicture">
			{image && <img src={image} alt="Photo" />}
		</div>
	);
};

ProfilePicture.propTypes = {
	image: PropTypes.string,
	size: PropTypes.number,
	sizesAt: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/support-organisations/profilePicture/component.js